import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import {Link} from "react-router-dom";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import 'datatables.net-fixedcolumns';
import {css} from "@emotion/core";
import * as moment from "moment";
import {connect}  from  "react-redux";
import loadingGif from "../../assets/img/loading.gif";
import {BeatLoader} from "react-spinners";
import {confirmAlert} from 'react-confirm-alert';
import { isApiResponse, isReportAccess, date_range_config, aplloClient, user_activities } from '../../helpers/utils.js';
import MultiCsvReportDownload from '../DownloadReport/MultiCsvReportDownload.jsx';
import UtidFilter from '../../filters/UtidFilter.jsx';
import DateRangeFilter from '../../filters/DateRangeFilter.jsx';
import AsoMultiFilter from '../../filters/AsoMultiFilter.jsx';

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;
var date_config = date_range_config('0', '0', '2020-02-01','0');
var LinkPKYCDocumentTable='';

class LinkPKYCDocument extends Component{
    constructor(props) {
        super(props);
        this.state ={
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            dateFromLimit: date_config.start_date_limit,
            dateLimit:date_config.end_date_limit,
            ciutidIds: '',
            loading:false,
            isChange: false,
            object_code:[],
            state_code:"",
            tableHeaders:[],
            tableBody:[],
            aso_names:"",
            download_limit:31,
            uid:''
        }

    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        isReportAccess(AllAccessPermissions, "crisp_merchant_kyc_document_report");
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");


        //isReportAccess(AllAccessPermissions, 'GRD_dump_report');
        if(decoded.object_type==='Merchant'){
            this.setState({
                merchantID: arrayCode
            })
        }
        if(decoded.object_type==='Chain'){
            this.setState({
                chainID: arrayCode
            })
        }
        if(decoded.object_type==='Store'){
            this.setState({
                storeID: arrayCode
            })
        }

        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
            userType: decoded.userType,
        });


    }
    componentDidUpdate() {

    }
    componentDidMount() {
        //this.get_download_limit();
        console.log(this.props)
        const params = new URLSearchParams(window.location.search);
        const mer_status = params.get('status');
        //alert(this.props.match.params.id);
        this.get_filtered_kyc_doc_report(this.props.match.params.id);
        this.setState({
            uid:this.props.match.params.id,
            mer_status:mer_status
            })
        user_activities(0, jwt_decode(localStorage.usertoken)._id, jwt_decode(localStorage.usertoken).firstName+' '+jwt_decode(localStorage.usertoken).lastName, jwt_decode(localStorage.usertoken).email,'live_transaction_dump_report','sparcs')

    }
    get_download_limit(){
        axios.get(config.get('API_URL')+'/filters/get-grd-download-limit/',
       {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {

            }
        }).then(response => {
            console.log(response.data);
            this.setState({
                download_limit:response.data
            })


        }).catch(error => {
          console.log(error);
        });
    }


    downLoadPkycDoc (e){


        let filters = {
            uid: this.state.uid,
            report_code:'link_kyc_documents',
            download: 1
        }
        this.setState({
            filters:filters
        })

        this.refs.downloadAllReport.downLoadReport(filters, '/internal_reports/merchant_pkyc_document','merchant_pkyc_document','');

    }

    get_filtered_kyc_doc_report(uid) {
//         console.log(tableHeaders);
//         console.log(tableBody);
        var that = this;
        var a = moment(this.state.todSend);
        var b = moment(this.state.yestSend);


        var postData = {
            uid: uid,
//             yestSend: this.state.yestSend,
//             todSend: this.state.todSend,
            report_code:'link_kyc_documents',
//             user_id: this.state.user_id,
        };
        if ($.fn.DataTable.isDataTable('#LinkPKYCDocumentTable')) {
            $('#LinkPKYCDocumentTable').DataTable().clear().destroy();
        }

        LinkPKYCDocumentTable = $('#LinkPKYCDocumentTable').DataTable(
            {
                order:[],
                //"dom": 'fltip',
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "sPaginationType": "numbers",
                "autoWidth": true,
                "responsive": false,
                "searching": false,
                //"scrollX": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
//                 fixedColumns:   {
//                                 leftColumns: 0,
//                                 rightColumns: 2
//                             },
                ajax: {
                    url:config.get('API_URL')+ "/CrispReport/link-pkyc-documents",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) {
                        isApiResponse(true);
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        isApiResponse(true);
                        alert("Failed to load data. Please try again");
                        console.log("error", data);
                    },
                    complete: function (data) {
                        isApiResponse(true)
                        console.log("complete", data);
                    },
                },

                columns:[
                    { "data": "Merchant Name" },
                    { "data": "Mobile" },
                    { "data": "KYC Document" },
                    { "data": "Status" },
                    { "data": "From Date" },
                    { "data": "To Date" },
                    { "data": "Approved By" },
                    { "data": "Approval Date" },
//                     { "data": "Last Update Date" },
                    { "data": "File Name" },

                    ],
                 "columnDefs": [
//                    {  render: function (data) {
//                             return "<div class='text-wrap width-80'>" +moment(data).format('D MMM YYYY HH:mm:ss')+ "</div>";
//                         },
//                         "width": "80px",
//                         "targets": 3
//                     }
// {
//                         render: function (data, type, full, meta) {
//                             if(data===null || data===''|| data ==='null'){
//                             data = '';
//                             }
//                             return "<div class='text-wrap width-150'>" + data + "</div>";
//                         },
//                         "targets": [0]

                {
                    "width": "50px",
                     "className":"text-center",
                    "targets": 8,
                    "data": "data",
                    "createdCell": (td, cellData, rowData, row, col) => {
                        $(td).text('');
                            if(rowData['File Name']) {
                                $(td).append('<a href="#"  data-tip="View" title="Re Run" id="re_run"  class="RerunButton" ><i class="fa fa-download"></i></a>');
                                $(td).click(e => {
                                    this.download_doc(e,rowData);
                                })
                            } else {
                                 $(td).append('NA');
                                }
                    },
                    bSortable: false,
                }
               ],
            });


    }
    download_doc(e, rowData){
    console.log(rowData)

    axios.post(config.get('API_URL') + '/CrispReport/download-doc/',
        {
           file_name:rowData['File Name'],
           mobile_number:rowData['Mobile'],
           is_old:rowData['is_old_merchant']
        },
        {
            headers: {
                Authorization: `${localStorage.usertoken}`
            }
        }
    ).then(response => {
        console.log(response.data)
        if (response.data.error && response.data.error.trim() !== "") {
          alert(response.data.error);
        }
        const downloadLink = response.data.data?.presigned_url; // Make sure your backend sends the link like { link: "https://..." }

        if (downloadLink) {
            const a = document.createElement('a');
            a.href = downloadLink;
            a.download = ''; // optional: set filename if you want
            //a.target = '_blank'; // optional
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        } else {
            console.error("No download link in response.");
        }
    }).catch(error => {
        console.error("Download error:", error);
    });


    }
    reset_all(e){
        this.refs.daterangeFilter.restDateFilter(date_config.start_date,date_config.end_date,date_config.display_start_date, date_config.display_end_date, date_config.start_date_value,date_config.end_date_value);
//         if(this.state.object_type==='Innoviti')
//         {
//
//             this.refs.reloadUtid.ci_utid('','','',false,'');
//         }
        this.refs.asoNameFilter.restAsoFilter();
        this.setState({
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            aso_names:'',
            ciutidIds: '',
            isChange: false

        })

        setTimeout(function(){
            this.componentWillMount()
            this.componentDidMount()
        }.bind(this), 200);
    }
    handleDateRange = (todSend, yestSend, datefromShow,dateToShow) =>
    {
        this.setState({
            todSend: todSend,
            yestSend: yestSend,
            datefromShow: datefromShow,
            dateToShow: dateToShow,
            isChange: true,
        });
    }
    handleAsoEvents = (optionSelected, event_names) =>
    {
        this.setState({
            aso_names:event_names,
            isChange: true
        });
    }
    goBack = () => {
        this.props.history.push('/admin/link-pkyc-report')
    }

    render() {
        return(
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">KYC documents of merchant</h4>
                                        <p className="category">Merchant Status - {this.state.mer_status}</p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                       <button type="button" className="primary reset-filter" role="button"  onClick={this.goBack}><i class="fa fa-arrow-circle-left"></i>Back</button>

                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">

{/*                                     <div className="row"> */}
{/*                                         <div className="col-md-12"> */}
{/*                                             <div className="col-md-2 filter-bottom5 padd-5 date-icon-small"> */}
{/*                                                 <div><label>Date Filter: </label></div> */}
{/*                                                 <DateRangeFilter ref="daterangeFilter" onSelectDate = {this.handleDateRange} start_date = {this.state.datefrom} end_date={this.state.dateTo} display_start_date = {this.state.datefromShow} display_end_date = {this.state.dateToShow} */}
{/*                                                 start_date_limit = {this.state.dateFromLimit} end_date_limit = {this.state.dateLimit}/> */}
{/*                                             </div> */}
{/*                                             <div className="col-md-3 filter-bottom5 padd-5"> */}
{/*                                                 <label> ASO Name </label> */}
{/*                                                 <AsoMultiFilter ref="asoNameFilter" onSelectaso = {this.handleAsoEvents} /> */}
{/*                                                 <div className="clearfix"></div> */}
{/*                                             </div> */}
{/*                                              */}
{/*                                         </div> */}

{/*                                     </div> */}
{/*                                     <div className="row"> */}
{/*                                         <div className="col-md-5 pull-right"> */}
{/*                                             {this.state.isChange===true? */}
{/*                                                 <span className="apply-notification">Please click on Apply button</span>:null */}
{/*                                             } */}
{/*                                             <button type="button" className="primary apply-filter" role="button" disabled={!this.state.isChange} onClick={this.get_filtered_kyc_doc_report.bind(this)}>Apply</button> */}
{/*                                             <button type="button" className="primary reset-filter" role="button"  onClick={this.reset_all.bind(this)}>Reset</button> */}
{/*                                         </div> */}
{/*                                     </div> */}


                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>

                                    <div className="">
                                        <a href="#" className="exportButton1" role="button" onClick={this.downLoadPkycDoc.bind(this)}>
                                            <i className="fa fa-download" aria-hidden="true"></i>
                                            Export to CSV
                                        </a>
                                    </div>
                                    <div className="clearfix"></div>

                                    <div className="content-tdetails-table table-full-width marginTop0">
                                        <table id="LinkPKYCDocumentTable" className="table table-striped table-hover">
                                            <thead>
                                            <tr>
                                                <th>Merchant Name</th>
                                                <th>Mobile</th>
                                                <th>KYC Document</th>
                                                <th>Status</th>
                                                <th>From Date</th>
                                                <th>To Date </th>
                                                <th>Approved By</th>
                                                <th>Approval Date</th>
{/*                                                 <th>Last Update Date</th> */}
                                                <th>Document Viewer</th>


                                            </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                    </div>
                                    <MultiCsvReportDownload ref="downloadAllReport" />

                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
        currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
}
export default connect(null,mapDispatchToProps)(LinkPKYCDocument)